import api from "../api/axios";

/**
 * Download a report from the backend, handling JSON error responses and blob downloads.
 * Sets backendError via the provided setter when an error response is detected.
 */
export async function downloadReport(
  endpoint: string,
  params: any,
  defaultFilename: string,
  setBackendError: (msg: string) => void
) {
  const res = await api.get(endpoint, { params, responseType: "blob" });
  const contentType = String(
    res.headers?.["content-type"] || "application/octet-stream"
  );

  if (contentType.includes("application/json")) {
    const text = await (res.data as any).text();
    try {
      const parsed = JSON.parse(text);
      const msg = parsed.error || parsed.detail || parsed.message || text;
      setBackendError(msg);
    } catch {
      setBackendError(text);
    }
    return;
  }

  const blob = new Blob([res.data], { type: contentType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  const disposition = res.headers?.["content-disposition"];
  let filename = defaultFilename;
  if (disposition && disposition.includes("filename=")) {
    const match = disposition.match(/filename="?([^";]+)"?/);
    if (match && match[1]) filename = match[1];
  }
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 100);
}
